import React from 'react';
import { formatToMoney } from 'utils';
import { Icon, Icons } from './Icon';
import { Link } from 'react-router-dom';

type Props = {
  iWillLogo: string;
  iWillPrice: number;
  iWillPackages: { title: string; info: string }[];
  iWillPlanId: number;
  isRecommended: boolean;
  isUseLink?: boolean;
};

export default function IWillPlanMobile({
  iWillLogo,
  iWillPrice,
  iWillPackages,
  iWillPlanId,
  isRecommended,
  isUseLink = true
}: Props) {
  return (
    <div className="flex flex-col items-center gap-y-1">
      {isRecommended ? (
        <button
          type="button"
          className="inline-flex w-full items-center justify-center rounded-t-[10px] bg-primary-900 px-3 py-2 text-center text-xs font-medium text-white"
        >
          RECOMMENDED
        </button>
      ) : (
        <div className="h-[2rem]"></div>
      )}
      <div
        className={`flex h-[535px] flex-col items-center justify-between rounded-[10px] border-[3px] ${
          isRecommended ? 'border-[#FF6606]' : 'border-[#FF660626]'
        }  px-2 py-10 pt-5`}
      >
        <div className="mb-3 flex flex-col">
          <div className="flex flex-col items-center">
            <img src={iWillLogo} className="w-8" />
            <p className="my-5 text-center font-circular text-base font-semibold">
              {formatToMoney(iWillPrice)}
            </p>
            <div
              className={`mb-2 w-3/4 border-[2px] ${
                isRecommended ? 'border-[#FF6606]' : 'border-[#35353533]'
              }`}
            />
          </div>
          {iWillPackages.map(packages => (
            <div
              key={packages.title}
              className="mt-4 flex items-center justify-between gap-0"
            >
              <div className="flex items-center gap-2">
                <p className="font-circular text-xs font-bold text-[#353535]">
                  {packages.title}
                </p>
                {/* <Icon name={Icons.Info} fill="#FF6600" /> */}
              </div>
              <Icon name={Icons.CheckMark} width={15} height={10} />
            </div>
          ))}
        </div>
        {isUseLink ? (
          <Link to={`/get-started/setup-account/${iWillPlanId}`}>
            <button
              type="button"
              className="inline-flex items-center rounded bg-primary-900 px-3 py-2 text-center text-xs font-medium text-white"
            >
              Get Started
            </button>
          </Link>
        ) : (
          <button
            type="button"
            className="inline-flex items-center rounded bg-primary-900 px-3 py-2 text-center text-xs font-medium text-white"
          >
            Get Started
          </button>
        )}
      </div>
    </div>
  );
}
